import { DetailTerm } from "./RegisterTermsService.styles";

export const TermCollect = () => {
  return (
    <DetailTerm>
      넥스트에너지 개인정보 취급방침 넥스트에너지 개인정보 취급방침 주식회사
      넥스트에너지는 귀하의 개인 정보보호를 매우 중요시하며 통신비밀보호법,
      전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신
      서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하고
      있습니다, 회사는 관련 법령에 의거한 개인정보취급방침을 정하여 이용자 권익
      보호와 개인정보처리 방침의 지속적인 개선을 위하여 최선을 다하겠습니다.
      넥스트에너지의 개인정보취급방침은 다음과 같은 내용을 담고 있습니다. 제1조.
      수집하는 개인정보의 항목 및 수집방법 가. 수집하는 개인정보의 항목
      넥스트에너지는 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해 아래와
      같은 개인정보를 수집하고 있습니다. 성명, 주민등록번호, 아이디, 비밀번호,
      본인확인문답, 이메일 주소, 전화번호 또한 서비스 이용과정이나 사업 처리
      과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다. - 이용자의
      브라우저 종류 및 OS, IP Address, 검색어, 서비스 이용 기록 - 방문 일시,
      주소, 결제기록, 쿠키, 서비스 이용기록, 불량 이용 기록 - 주소, 결제기록,
      쿠키 나. 개인정보 수집방법 넥스트에너지는 다음과 같은 방법으로 개인정보를
      수집합니다. - 홈페이지, 서면양식, 팩스, 전화, 상담 게시판, 이메일, 이벤트
      응모, 배송요청 - 생성정보 수집 툴을 통한 수집 제2조. 개인정보의 수집 및
      이용목적 가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
      컨텐츠 제공, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금 결제,
      요금추심 나. 회원관리 회원제 서비스 이용 및 제한적 본인 확인제에 따른
      본인확인, 개인식별, 불량회원의 부정 이용방지와 비인가 사용 방지, 가입의사
      확인, 가입 및 가입횟수 제한, 분쟁 조정을 위한 기록보존, 불만처리 등
      민원처리, 고지사항 전달 다. 신규 서비스 개발 및 마케팅 신규 서비스 개발 및
      맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의
      유효성 확인, 이벤트 및 광고성 정보 제공, 접속빈도 파악, 회원의 서비스
      이용에 대한 통계 제3조 개인정보 제3자 제공에 대한 동의 가. 회사는 회원이
      개인정보를 고지한 범위 내에서 사용하며 양질의 서비스 제공을 위하여 아래와
      같이 이용자의 동의를 구한후 제3자에게 개인정보를 제공합니다. 나. 다음의
      경우를 예외로 이용자의 사전 동의없이 이용자의 정보를 제공할수 있습니다 -
      법령에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우-
      조금 정산을 위하여 필요한 경우 - 이용자 또는 제3자의 급박한
      생명,신체,재산의 이익을 위하여 필요하다고 인정되는 경우 제4조. 개인정보의
      보유 및 이용기간 이용자의 개인정보는 원칙적으로 개인정보의 수집 및
      이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는
      아래의 이유로 명시한 기간 동안 보존합니다. 가. 관련법령에 의한 정보보유
      사유 상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에
      의하여 보존할 필요가 있는 경우 넥스트에너지 페쇄몰은 관계법령에서 정한
      일정한 기간 동안 회원정보를 보관합니다. 이 경우 넥스트에너지 페쇄몰은
      보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.
      [계약 또는 청약철회 등에 관한 기록] - 보존 이유 : 전자상거래 등에서의
      소비자보호에 관한 법률 - 보존 기간 : 5년 [대금결제 및 재화 등의 공급에
      관한 기록] - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률 - 보존
      기간 : 5년 [소비자의 불만 또는 분쟁처리에 관한 기록] - 보존 이유 :
      전자상거래 등에서의 소비자보호에 관한 법률 - 보존 기간 : 3년 [본인확인에
      관한 기록] - 보존 이유 : 정보통신 이용촉진 및 정보보호 등에 관한 법률 -
      보존 기간 : 5년 제5조. 개인정보 파기절차 및 방법 이용자의 개인정보는
      원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다.
      회사의 개인정보 파기절차 및 방법은 다음과 같습니다. 가. 파기절차 이용자가
      회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로
      옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한
      정보보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.
      동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로
      이용되지 않습니다. 나. 파기방법 종이에 출력된 개인정보는 분쇄기로
      분쇄하거나 소각을 통하여 파기합니다. 전자적 파일 형태로 저장된 개인정보는
      기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다. 제6조. 이용자 및
      법정대리인의 권리와 그 행사방법 이용자는 언제든지 등록되어 있는 자신의
      개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지
      않는 경우 동의를 거부하거나 가입해지(회원탈퇴)를 요청하실 수 있습니다.
      다만, 그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.
      이용자의 개인정보 조회, 수정을 위해서는 '개인정보변경'(또는 '회원정보수정'
      등)을, 가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭하여 본인 확인
      절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다 혹은
      개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이
      조치하겠습니다. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에
      정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한
      잘못된 개인정보를 제3 자에게 이미 제공한 경우에는 정정 처리결과를
      제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다. 회사는 이용자
      혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "5. 개인정보의
      보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는
      이용할 수 없도록 처리하고 있습니다. 제7조. 개인정보 자동 수집 장치의
      설치/운영 및 거부에 관한 사항 가. 쿠키란? 회사는 개인화되고 맞춤화된
      서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는
      '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가
      이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의
      하드디스크에 저장됩니다. 이후 이용자가 웹 사이트에 방문할 경우 웹 사이트
      서버는 이용자의 하드 디스크에 저장되어 있는 쿠키의 내용을 읽어 이용자의
      환경설정을 유지하고 맞춤화된 서비스를 제공하기 위해 이용됩니다. 쿠키는
      개인을 식별하는 정보를 자동적/능동적으로 수집하지 않으며, 이용자는
      언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다. 나. 회사의
      쿠키 사용 목적 이용자들이 방문한 네이버의 각 서비스와 웹 사이트들에 대한
      방문 및 이용형태, 인기 검색어, 보안접속 여부, 뉴스편집, 이용자 규모 등을
      파악하여 이용자에게 광고를 포함한 최적화된 맞춤형 정보를 제공하기 위해
      사용합니다. 제8조. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
      귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련
      민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는
      이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다. 제9조
      개인정보 관리책임자 정보 및 연락처 회사는 개인정보 처리에 관한 업무를
      책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제등을 위하여
      개인정보 보호책임자를 지정하고 있습니다. 개인정보 관리책임자 정보 및
      연락처 [개인정보 관리책임자] ㆍ이름 : 김현태 ㆍ소속 : 교육&레저부문 ㆍ전화
      : 02-536-0836 ㆍ직위 : 본부장 [개인정보 관리담당자] ㆍ이름 : 김현태 ㆍ소속
      : 교육&레저부문 ㆍ전화 : 02-536-0836 ㆍ직위 : 본부장 기타 개인정보침해에
      대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
      개인정보침해신고센터 (www.118.or.kr / 국번없이 118)
    </DetailTerm>
  );
};

export const TermService = () => {
  return (
    <DetailTerm>
      구매 시 주의사항 1. 모든 상품은 상품설명에 안내된 방법에 따라 구매 및 사용
      가능합니다. (상품설명 내 안내된 발송 또는 사용 및 예약방법 확인 필수) 2.
      모든 상품의 취소•환불 규정은 상품 별로 안내된 규정을 기준으로 합니다.
      (상품 별 조건 별 상이) 3. 넥스트에너지에서 판매하는 상품(티켓)은
      용역상품권으로, 모든 상품은 판매 시 안내된 내용만큼의 서비스를 제공받으실
      수 있습니다. ※ 금액상품권(3만원 이용권 등), 물품상품권(기프티콘 등)과 달리
      용역상품권은 정상요금이 아닌 특별판매요금으로 판매되는 상품이므로, 판매 시
      명시된 유효기간 만료 시 연장 또는 환불이 불가합니다.(전자상거래법 및
      상품권법 참조) 4. 재판매 또는 재판매를 목적으로 한 구매는 불법입니다. ※
      불법으로 구매한 상품(티켓)은 사용이 거절되거나 환불이 불가할 수 있습니다.
      5. 구매사이트 및 상품 내 안내된 내용을 확인하지 않아 발생하는 피해는
      보상받으실 수 없습니다.
    </DetailTerm>
  );
};
